export enum LegalEntitiesPlatformAccessType {
  "OfficerInvitations",
}
export enum LegalEntityAccessType {
  "Member Information",
  "Member Invitations",
  "Admin Invitations",
  "Signing Authority",
  "Member Permissions",
}

export enum DeprecatedLegalEntityAccessType {
  "Admin Invitations",
}
